export default __webpack_public_path__ + "static/media/arbitrum-logo.df0343ed.svg";